module.exports = __webpack_public_path__ + "img/75.3.TP.b6e15dfb.png";